export default {"src":"/_next/static/media/goggles.34cd1392.svg","height":129,"width":205,"blurWidth":0,"blurHeight":0};